import React from 'react';
import { getIn } from 'seamless-immutable';
import withQnA from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/qna';
import styled from 'styled-components';
import NoQuestion from '@catalogo/ui-americanas-desktop-svg/no-question.svg';
import { QuestionForm } from '@catalogo/ui-americanas-desktop-product-form/src/components/organisms/QuestionForm';
import Questions from '@catalogo/ui-americanas-desktop-svg/question.svg';

export const QnaAnchor = ({
  questionsAndAnswers,
  toQnAMetric,
  productId,
  currentSku,
  isMobile,
  product,
  config,
  dispatchMetrics,
}) => {
  const hasUsed = getIn(currentSku, ['offers', 'result', 0, 'condition']) === 'USED';
  const fontSize = isMobile ? 11 : 14;
  const total = getIn(questionsAndAnswers, ['meta', 'total'], 0);
  const qnaCount = `(${total} pergunta${total > 1 ? 's' : ''})`;

  const ButtonForm = !isMobile ? (
    <Link href={`/perguntar/${productId}`}>
      <IconNoQuestion />
      Faça a 1ª pergunta
    </Link>
  ) : (
    <QuestionForm
      className="anchor"
      productId={productId}
      product={product}
      config={config}
      dispatchMetrics={dispatchMetrics}
      metricParams={{
        category: 'qna-pdp',
        action: 'primeira-pergunta',
        label: 'abaixo-titulo',
      }}
    >
      <IconNoQuestion />
      Faça a 1ª pergunta
    </QuestionForm>
  );

  if (hasUsed) {
    return <></>;
  }

  if (!total && questionsAndAnswers !== null) {
    return <DivUi fontSize={fontSize}>{ButtonForm}</DivUi>;
  }

  return (
    !!total && (
      <Link href="#qna-wrapper" onClick={toQnAMetric} fontSize={fontSize}>
        <IconQuestion />
        {qnaCount}
      </Link>
    )
  );
};

const Link = styled.a`
  text-decoration: underline;
  color: #717171;
  font-size: ${({ fontSize }) => fontSize}px;
  display: flex;
  align-items: center;
  margin-left: 8px;
  text-transform: ${({ theme }) => theme.titleTransform};

  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const IconQuestion = styled(Questions)`
  margin-right: 6px;
  width: 16px;
  height: 16px;
`;

const IconNoQuestion = styled(NoQuestion)`
  margin-right: 6px;
  width: 16px;
  height: 16px;
`;

const DivUi = styled.div`
  font-size: ${({ fontSize }) => fontSize}px;
  margin-left: 8px;
`;

export default withQnA(QnaAnchor);
